import React from 'react';
import { useAppSelector } from "src/store/hooks";

import { Spin } from "antd";
import Pagination from 'src/componets/Pagination';

import '../style.scss';
import { EntityId } from "@reduxjs/toolkit";
import Card from "../../../mine_craft/Avatars/_partials/_Card";
import { selectAvatarEntities, selectAvatarIds } from "../../../../store/mine_craft/avatarsSlice";
import { selectUserEntities } from "../../../../store/mine_craft/usersSlice";
import Edit from "../Edit";

interface propsInterface {
  limit: number;
  pagination: boolean;
}

const _List = ({ limit, pagination }: propsInterface) => {
  const count  = useAppSelector(state => state.mineCraft.avatars.count);
  const error  = useAppSelector(state => state.mineCraft.avatars.error);
  const status = useAppSelector(state => state.mineCraft.avatars.status);
  const ids = useAppSelector(selectAvatarIds);
  const avatars = useAppSelector(selectAvatarEntities);
  const users = useAppSelector(selectUserEntities);

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  const renderAvatar = (id: EntityId) => {
    const avatar = avatars[id];

    if (!avatar) {
      return;
    }

    const user = avatar.user_id ? users[avatar.user_id] : undefined;

    return <Card avatar={avatar} user={user} key={`avatar-${id}`} />;
  }

  return (
    <>
      {ids && ids.map(renderAvatar)}

      {pagination && <Pagination total={count} size={limit} />}

      <Edit />
    </>
  );
}

export default _List;
